import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { MinMaxNumberControl } from '../../../form-models/minmaxnumber-control';

@Component({
  selector: 'hb-dynamic-min-max',
  templateUrl: './dynamic-min-max.component.html',
})
export class DynamicMinMaxComponent {
  @Input() control: MinMaxNumberControl;
  @Input() formGroup: FormGroup;

  @Output() onOverrideValue = new EventEmitter();

  constructor(private i18NextPipe: I18NextPipe) {}

  public overrideValue(): void {
    this.onOverrideValue.emit();
  }
}
